import * as React from "react";
//import { Input, InputNumber, DatePicker,Tooltip,Select } from 'antd';
import { Button, Input, Modal,Radio,message } from 'antd';
import { connect } from "react-redux";
import SmallTools from "widget/smallTools";
import {throttle} from "utils/tool";
import Acttachlist from "widget/orderButtonGroup/acttachlist";
const RadioGroup = Radio.Group;

interface Data {
  hotelInfo: any;
  id?:any;
  getHotel?:any;
  data: any;
  updateDataValue:any;
  readonly:any;
  getHotelList:any;
  add:any;
  orderDetails:any;
  check:any;
  skuId:any;
}

class hotelInfo extends React.Component<Data> {
  state = {
    hotelInfo:[],
    visible:false,
    hotelData:[],
    openKey:100,
    data:{},
    readonly:{},
    orderDetails:{},
    hotelList:[],
    isAdd:false,
    name:'新增',
    title:'从酒店库中添加',
    hotel_engname:'',
    tel:'',
    address:'',
  };

  constructor(props: Data) {
    super(props);
    this.onChange = throttle(this.onChange.bind(this), 200);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {

    if(!nextProps.hotelInfo){
      return false;
    }
    if (prevState.hotelInfo.length != nextProps.hotelInfo.length) {
      this.setState({
        hotelInfo: nextProps.hotelInfo,
        data: nextProps.data,
        readonly:nextProps.readonly
      });
      //if(nextProps.orderDetails['phone']){
      //  this.getHotel(nextProps.orderDetails['phone']);
      //}
      return false;
    }
    return true;
  }

  getName = (item) => {
    let name ='';
    for (var value of item ){
        if(value.f_type == 'search'){
           name = value.ch_name;
           break;
        }
    }
    return name;
  }

  getReadonly = (item) => {
    let isReadonly =0;
    for (var value of item ){
        if(value.f_type == 'search'){
           isReadonly = this.state.readonly[value.id];
           break;
        }
    }
    return isReadonly;
  }

  showModal = (key,readonly) => {
    if(readonly == 1){
      message.info("当前订单状态不可选择酒店");
       return;
    }
    this.getHotel(this.props.orderDetails['phone']);
    this.setState({
      visible: true,
      openKey:key
    });
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }

  getFeild = (item) => {
    let feild  : any = [];
    for (var value of item ){
        if(value.htype == 'hotel_engname'){
          feild.push(<p key={value.id}><label>名称</label><span className="li-right"><Input disabled value={this.state.data[value['id']]}/></span></p>)
        }
        if(value.htype == 'tel'){
          feild.push(<p key={value.id}><label>电话</label><span className="li-right"><Input disabled value={this.state.data[value['id']]}/></span></p>)
        }
        if(value.htype == 'address'){
          feild.push(<p key={value.id}><label>地址</label><span className="li-right"><Input disabled value={this.state.data[value['id']]}/></span></p>)
        }
    }
    return feild;
  }
  
  searchHotel = (e) =>{
    // throttle(this.onChange(e), 200);
     e.persist();
     this.onChange(e)
  }

  change = (key,value) =>{
      console.log(value.target.value)
      if(key == 'tel'){
        this.setState({
          tel: value.target.value,
        });        
      }
      if(key == 'address'){
        this.setState({
          address: value.target.value,
        });        
      }
      if(key == 'hotel_engname'){
        this.setState({
          hotel_engname: value.target.value,
        });        
      }
  }

  onChange = (e) =>{
    if(e.target.value == null){
       return;
    }
    const param: any = {
      order_id: this.props.id,
      name:e.target.value
    };
    this.props.getHotel({
      ...param,
      callback: (data) => {
        this.setState({
          hotelData: data,
        });
      }
     });
  }


  getHotel= (phone) =>{
    const param: any = {
      phone: phone
    };
    this.props.getHotelList({
      ...param,
      callback: (data) => {
        this.setState({
          hotelList: data,
        });
      }
     });
  }

  creatFrom = () => {  
    const listItems = this.state.hotelInfo.map((item, key) => {
      const name = this.getName(item);
      const feild = this.getFeild(item);
      const readonly = this.getReadonly(item);
       return(
       <div className="hotel" key={key}>
          <div className="hotel-top">
             <div className="name">{name}</div><div className="select"><a onClick={this.showModal.bind(this,key,readonly)} >选择</a></div>
          </div>
         {feild}
        </div>
       )
    })
    return (<React.Fragment>{listItems}</React.Fragment>);
  };
  
  hotelClickbefore = (key,type:any) => {
    if(type != 'add'){
      let list = {};
      list = this.state.hotelData[key]; 
      const param: any = {
        hotel_id: list['id'],
        id:this.props.skuId,
      };
      this.props.check({
        ...param,
        callback: (data) => {
           if(data.res.code !='0000'){
               message.error(data.res.msg)
           }else{
               this.hotelClick(key,type);
           } 
        }
       }); 
    }else{
      this.hotelClick(key,type);
    }
  }

  hotelClick = (key,type:any) => {
      console.log(this.state.hotelData[key],this.state.openKey);
      let list = {};
      if(type == 'hotelList'){
        list = this.state.hotelList[key];   
      }else if(type == 'add'){
        list = {
           'hotel_engname':this.state.hotel_engname,
           'tel':this.state.tel,
           'address':this.state.address,
        }  
      }else{
        list = this.state.hotelData[key];
      }
      let data = this.state.data;
      for (let value of this.state.hotelInfo[this.state.openKey] ){
           if(value['htype'] == 'hotel_engname'){
              this.props.updateDataValue({id:value['id'],value:list['hotel_engname']});
              data[value['id']] =list['hotel_engname'] 
           }
           if(value['htype'] == 'tel'){
             this.props.updateDataValue({id:value['id'],value:list['tel']});
             data[value['id']] =list['tel'] 
           }
           if(value['htype'] == 'address'){
             this.props.updateDataValue({id:value['id'],value:list['address']});
             data[value['id']] =list['address']
           }     
      }  
      this.setState({
        data:data 
      });
      this.handleCancel();    
  }

  creatHotel = () => {
    if(this.state.hotelData instanceof Array){ 
      const listItems = this.state.hotelData.map((item, key) => {
        return(
          <li key={item['id']} onClick={this.hotelClickbefore.bind(this,key)}> 
          <div className="hotel-name">{item['hotel_engname']}   {item['hotel_chname']}</div>
          <div className="hotel-address">{item['address']}</div>
          </li>
        )
      })
      return (<React.Fragment>{listItems}</React.Fragment>);
    }else{
      return('');
    }
  };
  
  changeHotel = (e) => {
       console.log(e)
       this.hotelClick(e.target.value,'hotelList');    
  }

  submit = () => {
    this.hotelClick(0,'add'); 
    const param: any = {
      hotel_engname: this.state.hotel_engname,
      address: this.state.address,
      tel: this.state.tel,
      order_id:this.props.id,
    };
    this.props.add({
      ...param,
      callback: (data) => {}
     });       
  }  
  
  reset = () =>{
    this.setState({
      hotel_engname:'',
      tel:'',
      address:'',
    });
  }

  hotelList = () => {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    const listItems = this.state.hotelList.map((item, key) => {
         return(<Radio key={key} style={radioStyle}  value={key}>{item['hotel_engname']}</Radio>); 
    })
    return (<React.Fragment>{listItems}</React.Fragment>);
  }
  
  isAdd = (type) => {
    console.log(this.state.isAdd);
    if(this.state.isAdd){
      if(type =='a'){
         return "hide";
      }else{
         return "up";
      }
    }else{
        if(type =='b'){
          return "hide";
        }else{
          return "up";
        }
     }
  }
  
  changeAdd = () => {
    if(this.state.isAdd){
      this.setState({
        isAdd:false,
        name:'新增', 
        title:'新增酒店',
      });
    }else{
      this.setState({
        isAdd:true,
        name:'从酒店中选择', 
        title:'从酒店库中添加',
      });    
    }
  }

  render() {

    if(this.state.hotelInfo.length == 0){
      return false;
    }else{
      return (
        <td>
        <div className='hotel-info'>
        <div className="surcharge">交通附加费：{this.props.orderDetails.surchargeAmount} <Acttachlist /></div>
        <div className="hotel-from">
        <SmallTools
            content={this.creatFrom()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
        /> 
        </div>
        <Modal
          title="选择酒店"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          width={1000}
          centered={true}
          className="hotel-model"
        >
        <div className="hotel-search">
           <div className="hotel-left">
              <p><label>常用酒店列表</label></p>
              <div>
              <RadioGroup onChange={this.changeHotel} value={-1} >
               {this.hotelList()}
              </RadioGroup>                 
              </div>
           </div>
           <div className="hotel-right">
           
           <p><label>{this.state.title}</label><a onClick={this.changeAdd}>{this.state.name}</a></p> 
           <div className={this.isAdd('a')}>
           <Input placeholder="请输入酒店关键词" onChange={this.searchHotel} />
           <ul>
           <SmallTools
            content={this.creatHotel()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
            display={true}
           />
           </ul>
           </div>
           <div className={this.isAdd('b')}>
           <div className="from-add">
           <Input value={this.state.hotel_engname} onChange={this.change.bind(this,'hotel_engname')} placeholder="请输入酒店英文名称" />
           <Input value={this.state.tel} onChange={this.change.bind(this,'tel')} placeholder="请输入酒店电话" />
           <Input value={this.state.address} onChange={this.change.bind(this,'address')} placeholder="请输入酒店地址" />
           <div className="from-button">
           <Button onClick={this.reset}>重置</Button>
           <Button type="primary" onClick={this.submit}>确认</Button>
           </div>
           </div>
           </div>         
           </div>
        </div>
        </Modal>      
        </div> 
        </td>
      );
    }
  }
}


const mapState = state => ({
  id:state.orderDetails.id,
  orderDetails:state.orderDetails,
  skuId:state.orderDetails.skuId,
});

const mapDispatch = dispatch => {
  const oi = dispatch.orderDetails;
  return {
    // 获取订单详情
    getHotel: oi.getHotel,
    getHotelList:oi.getHotelList,
    add:oi.add,
    check:oi.check,
  };
};

export default connect(
  mapState,
  mapDispatch
)(hotelInfo);

